import { DetailsOpenStatus } from 'src/common/interface';
/**
 * CheckinSelect model details
 */
export interface CheckinSelectStateDetails {}

/**
 * CheckinSelect store state
 */
export interface CheckinSelectState extends CheckinSelectStateDetails {
  model: DetailsOpenStatus;
}

/**
 * Name of the CheckinSelect Store
 */
export const CHECKIN_SELECT_STORE_NAME = 'checkinSelect';

/**
 * CheckinSelect Store Interface
 */
export interface CheckinSelectStore {
  /** CheckinSelect state */
  [CHECKIN_SELECT_STORE_NAME]: CheckinSelectState;
}
